import { landmineNames } from '@mm/constants/landmine-names';
import { TemplatesController } from '@mm/state/controllers/TemplatesController';
import { PageBillingType } from '@mm/state/interfaces/connected-page';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPagePlanInfoSelector } from '@mm/state/selectors/facebookPageSelector';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import classNames from 'classnames';
import { trimStart } from 'lodash';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { RouterComponentProps } from '../../../../../common/helpers/routes/interfaces';
import CreateBotOrExtendByTemplate from '../../components/CreateBotOrExtendByTemplate/CreateBotOrExtendByTemplate';
import './TemplateByCodePanel.scss';

type Props = ReturnType<typeof mapStateToProps> & RouterComponentProps;

const TemplateByCodePanelPure = (props: Props) => {
  const { freeOrSpecialPricePlan } = props;

  const [value, setValue] = useState('');
  const [validityMessage, setValidityMessage] = useState('');
  const [isInProgress, setIsInProgress] = useState(false);
  const [searchToken, setSearchToken] = useState(
    undefined as string | undefined,
  );
  const [isCreateBot, setIsCreateBot] = useState(false);
  const modalActions = useModalActions();

  const closeModal = () => {
    setSearchToken(undefined);
    setIsCreateBot(false);
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (freeOrSpecialPricePlan) {
      return modalActions.openUniversalUpgradeLandmineModal({
        landmineName: landmineNames['TEMPLATES__BY-CODE__SUBMIT'],
        planFallback: PageBillingType.Pro,
      });
    }

    if (!validityMessage) {
      try {
        await TemplatesController.verifyCodeExistance(value);
        setSearchToken(value);
        setValidityMessage('');
        setIsCreateBot(true);
      } catch (err) {
        setValidityMessage('Template does not exist');
      }
    }
  };

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!/^[a-z0-9]*$/.test(e.target.value)) {
      setValidityMessage('Invalid Code Format');
    } else {
      setValidityMessage('');
    }

    setValue(trimStart(e.target.value));
  };

  const className = classNames('template-by-code-panel');

  return (
    <div>
      <p className="template-by-code-panel__info">
        Paste a Customers.ai template code that you received from a colleague or
        from the community.
      </p>

      <form onSubmit={onSubmit} className={className}>
        <fieldset disabled={isInProgress}>
          <label className="template-by-code-panel__label">
            <div className="template-by-code-panel__group">
              <input
                name="templateCode"
                type="text"
                className="template-by-code-panel__input"
                onInput={onInputChange}
                value={value}
                autoComplete="off"
                placeholder="Paste your code here"
              />
              <Button blue className="template-by-code-panel__btn">
                GO
              </Button>
            </div>

            <div
              className={`template-by-code-panel__notes \
              template-by-code-panel__notes_${!!validityMessage}`}
            >
              {validityMessage || 'empty'}
            </div>
          </label>
        </fieldset>
      </form>
      {isCreateBot && searchToken !== undefined && (
        <CreateBotOrExtendByTemplate
          onClose={closeModal}
          searchToken={searchToken}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  chatbotId: activeChatbotIdSelector(state),
  freeOrSpecialPricePlan:
    activeFacebookPagePlanInfoSelector(state).info.isFreeOrSpecialPlan,
});

export const TemplateByCodePanel = connect(
  mapStateToProps,
  null,
)(TemplateByCodePanelPure);
